import React from 'react';
import FaceSwapIntro from './FaceSwapIntro';
import FaceSwapUpload from './FaceSwapUpload';
import FaceSwapHistory from './FaceSwapHistory';
import FaceSwapHowTo from './FaceSwapHowTo';
import FaceSwapTechFeatures from './FaceSwapTechFeatures';
import './FaceSwapMain.css';

const FaceSwapMain: React.FC = () => {
  return (
    <main className="face-swap-main">
      <div className="main-container">
        {/* Feature Intro Section */}
        <div className="feature-intro-section">
          <FaceSwapIntro />
          <FaceSwapUpload />
        </div>
        
        {/* History Section */}
        <FaceSwapHistory />
        
        {/* How To Section */}
        <FaceSwapHowTo />
        
        {/* Tech Features Section */}
        <FaceSwapTechFeatures />
      </div>
    </main>
  );
};

export default FaceSwapMain;